import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=379f6e1a&scoped=true&lang=pug&"
import script from "./Intro.vue?vue&type=script&lang=js&"
export * from "./Intro.vue?vue&type=script&lang=js&"
import style0 from "./Intro.vue?vue&type=style&index=0&id=379f6e1a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379f6e1a",
  null
  
)

component.options.__file = "Intro.vue"
export default component.exports